import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=295bdf4a&scoped=true"
import script from "./ElementList.vue?vue&type=script&lang=js"
export * from "./ElementList.vue?vue&type=script&lang=js"
import style0 from "./ElementList.vue?vue&type=style&index=0&id=295bdf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bdf4a",
  null
  
)

export default component.exports